import React, { useCallback, useEffect, useState } from 'react'
import SideBar from '../SideBar.js'
import Header from '../../Header/Header.js'
import BillingHeader from './BillingHeader.js'
import Table from "../../components/Table/index.jsx";
import { useLazyQuery, useQuery } from '@apollo/client'
import { GET_ORDERS } from '../../graphql/Query/Order.js'
import moment from 'moment'
import DateFilter from '../../Common/DateRange.js'
import { getDateRange } from '../../Common/GetDateRange.js'
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { FiDownload } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
const ShippingCharges = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const awbNumberData = queryParams.get("awb");
    const [fetchAllOrders] = useLazyQuery(GET_ORDERS, {
        fetchPolicy: "cache-and-network"
    });
    const [finalRange, setFinalRange] = useState({
        filterType: "Life Time",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [awbNumber, setawbNumber] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);
    const [filter, setFilter] = useState('');
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_ORDERS, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            tag: 'All Courier',
            "filter": filter?.trim() ? filter?.trim() : awbNumberData,
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
        },
        fetchPolicy: "cache-and-network",
    });

    const handleSearch = (e, awb) => {
        if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);
    }

    useEffect(() => {
        if (GetOrderOrder?.getOrders?.data) {
            setOrderData(GetOrderOrder?.getOrders?.data);
        }
    }, [GetOrderOrder]);

    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);

    const transformDataForExport = (data) => {
        return data?.map((shipment) => {
            return {
                "Shipment Created": moment(shipment?.createdAt).format('DD/MM/YYYY'),
                "Product SKU": shipment?.order_number,
                "Products": shipment?.ProductName,
                "AWB Number": shipment?.awb_number,
                Status: shipment?.status,
                "Freight Charges": shipment?.freight_charges ? shipment?.freight_charges : "-",
                "COD Charges": shipment?.cod_charges ? shipment?.cod_charges : "-",
                "ENTERED WGT(KG)": shipment?.package_weight_Length ? shipment?.package_weight_Length : "-",
                "APPLIED WGT(KG)": shipment?.applied_weight ? shipment?.applied_weight : 0,
                "Extra Weight(KG)": shipment?.extra_weight_charges ? shipment?.extra_weight_charges : 0,
                "RTO Charges": shipment?.rto_order_charge ? shipment?.rto_order_charge : 0,
                "COD Charge Reversed": shipment?.cod_charge_reversed ? shipment?.cod_charge_reversed : 0,
                "RTO Extra Wgt Charges": shipment?.rto_extra_weight_charges ? shipment?.rto_extra_weight_charges : 0,
                "TOTAL CHARGES": shipment?.final_order_amount ? shipment?.final_order_amount : 0,

            };
        });
    };

    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: 1,
                limit: 100000,
                "sort": {
                    "key": "createdAt",
                    "type": -1
                },
                tag: 'All Courier',
                "filter": filter.trim(),
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),

            },
            fetchPolicy: "cache-and-network"
        });

        if (!data?.getOrders?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getOrders?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipping_charges");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "Shipping_charges.xlsx");
    };

    const columns = [
        {
            name: "Shipment Created",
            selector: (row) =>
                row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-",
            sortable: true,
            width: "180px",
            cell: (row) => (
                <span className="text-xs">
                    {row?.createdAt ? moment(row.createdAt).format("MMM DD, YYYY hh:mm A") : "-"}
                </span>
            ),
        },

        {
            name: "AWB Number",
            selector: (row) => row?.awb_number ?? "-",
            sortable: true,
            cell: (row) => (row?.awb_number ?
                <span
                    style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }}
                    className='text-xs'
                    onClick={() => window.open(`/dashshipment?awb=${row?.awb_number}`, "_blank")}
                >
                    {row?.awb_number}
                </span> : "-"
            ),
        },
        {
            name: "Status",
            selector: (row) => (
                <span className="text-xs">
                    {row?.status.toUpperCase() ?? "-"}
                </span>
            ),
            sortable: true
        },
        // {
        //     name: "Freight Charges (₹)",
        //     selector: (row) => row?.freight_charges ?? "-",
        //     sortable: true
        // },
        {
            name: "Freight Charges (₹)",
            selector: (row) => (
                <span className="text-xs">
                    {(() => {
                        const targetDate = new Date("2025-03-18T00:00:00");
                        const rowDate = new Date(row?.createdAt);

                        return rowDate <= targetDate
                            ? row?.order_amount ?? "-"
                            : row?.freight_charges ?? "-";
                    })()}
                </span>
            ),

            sortable: true
        },
        {
            name: "COD Charges (₹)",
            selector: (row) => (
                <span className="text-xs">
                    {row?.cod_charges ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "Entered Wgt (kg)",
            selector: (row) => (
                <span className="text-xs">
                    {parseFloat(row?.package_weight_Length) ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "Applied Wgt (kg)",
            selector: (row) => (
                <span className="text-xs">
                    {row?.applied_weight ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "Extra Wgt Charges (₹)",
            selector: (row) => (
                <span className="text-xs">
                    {row?.extra_weight_charges ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "RTO Charges (₹)",
            selector: (row) => (
                <span className="text-xs">
                    {row?.rto_order_charge ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "COD Charge Reversed",
            selector: (row) => (
                <span className="text-xs">
                    {row?.cod_charge_reversed ? `-${row?.cod_charge_reversed}` : "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "RTO Extra Wgt Charges",
            selector: (row) => (
                <span className="text-xs">
                    {row?.rto_extra_weight_charges ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "Total Charges (₹)",
            selector: (row) => (
                <span className="text-xs">
                    {row?.final_order_amount ?? "-"}
                </span>
            ),
            sortable: true
        },
        {
            name: "ACTION",
            cell: (row) => (
                <button
                    className='flex items-center gap-2 px-3 py-1 text-xs text-[#5C74FB] border border-[#5C74FB] rounded-md shadow-sm hover:shadow-md hover:bg-[#5C74FB] hover:text-white transition'
                    onClick={() => window.open(`/wallettransactions?awb_number=${row?.awb_number}`, "_blank")}
                >
                    View
                </button>
            ),
            width: "100px",
        },
    ];

    const resetData = () => {
        setPage(1);
        setFilter("");
        setawbNumber("");
        const defaultRange = getDateRange("Life Time");
        setFinalRange({
            filterType: "Life Time",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Life Time",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }

    return (
        <div>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}
                <SideBar />
                <div className="flex-1 space-y-3 md:p-6 py-6 overflow-x-hidden ml-16">
                    <div className='bg-white '>
                        <BillingHeader />
                        <div className="flex px-6 md:mt-3 mt-7 mb-3 md:mb-0 justify-end">
                            <button
                                onClick={downloadExcel}
                                className="flex items-center gap-2 text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto"
                            >
                                <FiDownload className="text-lg" /> Export
                            </button>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 px-6 pb-7 lg:grid-cols-2 xl:grid-cols-3 gap-4">

                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />
                            </div>
                            {/* AWB No. */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">AWB No.</label>
                                <input
                                    type="text"
                                    value={awbNumber}
                                    onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber'); }}
                                    placeholder="AWB Nos (comma-separated)"
                                    className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                />
                            </div>
                            <div className="flex items-end h-full" onClick={resetData}>
                                <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                    Reset Filters
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Main Content */}

                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <Table
                            columns={columns}
                            data={orderData}
                            currentPage={page}
                            totalRecords={GetOrderOrder?.getOrders?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            // onSort={handleSort}
                            handlePagination={handlePagination}
                        // multiSelectRow={onSelectedRowsChange}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ShippingCharges
